<template>
  <div class="kpt-apploader">
    <!-- <div class="pong-loader"></div> -->
    <div class="kpt-app-progress">
      <h3 class="is-uppercase has-text-centered has-text-weight-bold">Loading</h3><br>
      <b-progress type="is-info" size="is-large" :value="value" :max="max" show-value>
        {{currentlyLoading || 'Loading...'}}
      </b-progress>
    </div>
    
  </div>
</template>
<script>
export default {
  computed: {
    currentlyLoading() {
      return this.$store.state.system.loader.currentlyLoading;
    },
    value() {
      return this.$store.state.system.loader.loadCount;
    },
    max() {
      return this.$store.state.system.loader.dispatches.length;
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../styles/colors';

.kpt-apploader {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 9999;
  background: white;
  display: grid;
  place-items: center;
  background-image: url('~@/assets/network1.png');
  background-position: center center;
  background-repeat: no-repeat;

  .kpt-app-progress {
    width: 300px;
    height: 100px;
  }
}

.kpt-app-loader {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  background: white;

  $color: #5b81a9;

  .pong-loader {
  position: absolute;
  margin: 0 auto;
  left: 0;
  right: 0;
  top: 50%;
  height: 40px;
  width: 6px;
  background-color: transparent;
  animation: paddles 0.75s ease-out infinite;
  transform: translate3d(0,0,0);
  
  &:before {
    content: "";
    position: absolute;
    margin: 0 auto;
    left: 0;
    right: 0;
    top: 15px;
    width: 10px;
    height: 10px;
    background-color: $color;
    border-radius: 50%;
    animation: ballbounce 0.6s ease-out infinite;
  }
}

@keyframes paddles {
  0% {
    box-shadow: -25px -10px 0px $color, 25px 10px 0px $color;
  }
  50% {
    box-shadow: -25px 8px 0px $color, 25px -10px 0px $color;
  }
  100% {
    box-shadow: -25px -10px 0px $color, 25px 10px 0px $color;
  }
}

@keyframes ballbounce {
  0%{
    transform: translateX(-20px) scale(1,1.2);
  }
  25%{
    transform: scale(1.2,1);
  }
  50% {
    transform: translateX(15px) scale(1,1.2);
  }
  75% {
    transform: scale(1.2,1);
  }
  100% {
    transform: translateX(-20px);
  }
}
}
</style>
